import { applyMargin, roundDownToTwoDecimals } from '@utils/currency';
import { formatCheckoutQuoteDisplay } from '@v2/components/BuyPackageHeader/checkout-header-quote';
import {
  sumWholesaleTicketTax,
  type TicketTaxQuote,
} from './ticket-tax-quotes';

export function getTicketQuotePrice(
  retailPrice: number,
  quantity: number,
  quote: TicketTaxQuote,
  priceRate: number,
  currency: string
) {
  const subtotal = roundDownToTwoDecimals(
    retailPrice * quantity + sumWholesaleTicketTax(quote)
  );
  const amount = Number(applyMargin(subtotal, priceRate, currency));
  return {
    amount,
    travelers: quantity,
    currency,
    display: formatCheckoutQuoteDisplay({
      amount,
      travelers: quantity,
      currency,
    }),
  };
}
